import { render } from "./AppEmptyState.vue?vue&type=template&id=63bfee9e"
import script from "./AppEmptyState.vue?vue&type=script&lang=js"
export * from "./AppEmptyState.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__